<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2023 (original work) Open Assessment Technologies SA ;
    import { __ } from '@oat-sa-private/ui-core';
    import { Icon, Input } from '@oat-sa-private/ui-elements';

    let hidden = true;

    $: type = hidden ? 'password' : 'text';
    $: btnAriaLabel = hidden ? __('Show password') : __('Hide password');

    function toggleHidden() {
        hidden = !hidden;
    }
</script>

<style>
    .hide-button {
        background-color: transparent;
        border: none;
        font-size: var(--fontsize-body);
        border-radius: 50%;
        /* compensates input border in focused state */
        margin-right: calc(var(--border-thin) * 2);
        --size: calc(2.75rem + var(--padding-y) * 2 - var(--border-thin) * 2);
        height: var(--size);
        width: var(--size);

        &:hover, &:focus {
            background-color: var(--color-bg-actionable-secondary-hover);
            cursor: pointer;
        }
    }

    /* global because of mixin */
    :global(input .suffix-wrapper .hide-button) {
        @add-mixin outline-focus 0;

        &:focus-visible::after {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border: var(--border-medium) dotted;
            border-color: var(--color-border-focus);
            border-radius: 50%;
        }
    }
</style>

<Input
    {...$$props}
    {type}
    on:validation
    on:change
>
    <button slot="suffix" type="button" class="hide-button" on:click|stopPropagation={toggleHidden} aria-label={btnAriaLabel}>
        <Icon name={hidden ? 'eye-16' : 'eye-crossed-16'} />
    </button>
</Input>
